import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.EmbeddedDealPage.components.Drafts.title',
    defaultMessage: 'Order Draft',
  },
  supplierTitle: {
    id: 'containers.EmbeddedDealPage.components.Drafts.supplierTitle',
    defaultMessage: 'Supplier',
  },
  taskTypeTitle: {
    id: 'containers.EmbeddedDealPage.components.Drafts.taskTypeTitle',
    defaultMessage: 'Task type',
  },
  costTitle: {
    id: 'containers.EmbeddedDealPage.components.Drafts.costTitle',
    defaultMessage: 'Cost',
  },
  priceTitle: {
    id: 'containers.EmbeddedDealPage.components.Drafts.priceTitle',
    defaultMessage: 'Price',
  },
  discountTitle: {
    id: 'containers.EmbeddedDealPage.components.Drafts.discountTitle',
    defaultMessage: 'Discount',
  },
  wrongPriceCurrency: {
    id: 'containers.EmbeddedDealPage.components.Drafts.wrongPriceCurrency',
    defaultMessage: 'Be aware you have selected a currency which differs from the companies preferred currency',
  },
  addTask: {
    id: 'containers.EmbeddedDealPage.components.Drafts.addTask',
    defaultMessage: 'Add task',
  },
  bulkAddTaskTitle: {
    id: 'containers.EmbeddedDealPage.components.Drafts.bulkAddTaskTitle',
    defaultMessage: 'Bulk add task',
  },
  bulkAddAdd: {
    id: 'containers.EmbeddedDealPage.components.Drafts.bulkAddAdd',
    defaultMessage: 'Add',
  },
  bulkAddCancel: {
    id: 'containers.EmbeddedDealPage.components.Drafts.bulkAddCancel',
    defaultMessage: 'Cancel',
  },
  bulkAddTaskButton: {
    id: 'containers.EmbeddedDealPage.components.Drafts.bulkAddTaskButton',
    defaultMessage: 'Bulk add task',
  },
  saving: {
    id: 'containers.EmbeddedDealPage.components.Drafts.saving',
    defaultMessage: 'Saving..',
  },
  addVersionLabel: {
    id: 'containers.EmbeddedDealPage.components.Drafts.addVersionLabel',
    defaultMessage: 'Version language',
  },
  addVersionDescription: {
    id: 'containers.EmbeddedDealPage.components.Drafts.addVersionDescription',
    defaultMessage: 'Select a language to create a version',
  }
})
